import NFTCoreContract from "src/contract-logic/logic/NFTCoreContract";
import NFTManagerContract from "src/contract-logic/logic/NFTManagerContract";
import multiCall from "src/utils/multicall";
import moment from "moment";
import NFTTransmutationContract from "src/contract-logic/logic/NFTTransmutationContract";

export default class EquipmentQuery {
  static async fetchEquipmentByAddress(accountAddress) {
    const tokenLength = await NFTCoreContract.getBalance(accountAddress);
    const [tokenIds] = await Promise.all([
      multiCall(
        NFTCoreContract.ABI,
        new Array(tokenLength).fill(1).map((_, idx) => ({
          address: NFTCoreContract.ADDRESS,
          name: "tokenOfOwnerByIndex",
          params: [accountAddress, idx],
        }))
      ),
    ]);
    const tokenIdsFlattened = tokenIds.flat();
    const [data] = await Promise.all([
      multiCall(
        NFTManagerContract.ABI,
        tokenIdsFlattened.map((tokenId) => ({
          address: NFTManagerContract.ADDRESS,
          name: "checkIfChestOpenedAndSet",
          params: [tokenId],
        }))
      ),
    ]);
    const openedTokens = [];
    tokenIdsFlattened.forEach((tokenId, index) => {
      const version = parseInt(data[index][0]);
      const isOpen = data[index][1];
      if (isOpen) openedTokens.push({ tokenId, version });
    });

    const [tokensMetadata] = await Promise.all([
      multiCall(
        NFTCoreContract.ABI,
        openedTokens.map((item, _) => ({
          address: NFTCoreContract.ADDRESS,
          name: "getTokenMetadata",
          params: [item.tokenId],
        }))
      ),
    ]);
    const tokensMetadataFlattened = tokensMetadata.flat();
    let v1 = {};
    let v2 = {};
    let temp = tokensMetadataFlattened.map((item, index) => ({ ...item, ...openedTokens[index] }));
    temp.forEach((item) => {
      if (parseInt(item.collectionId) !== 0) {
        const data = {
          tokenId: parseInt(item.tokenId),
          version: item.version,
          set: parseInt(item.collectionId),
          rarity: parseInt(item.tokenRarity),
          type: parseInt(item.tokenType),
          exp: parseInt(item.experiencePoint),
        };
        if (item.version == 1) v1[item.tokenId] = data;
        else if (item.version == 2) v2[item.tokenId] = data;
      }
    });
    return { v1, v2 };
  }

  static async fetchForgingEquipmentByAddress(accountAddress) {
    const countAllForgingItem = await NFTTransmutationContract.getForgingLengthOfOwner(accountAddress);
    const tokenIds = await multiCall(
      NFTTransmutationContract.ABI,
      new Array(countAllForgingItem).fill(1).map((_, idx) => ({
        address: NFTTransmutationContract.ADDRESS,
        name: "getForgingIdOfOwnerAtIndex",
        params: [accountAddress, idx],
      }))
    );
    const tokenIdsFlattened = tokenIds.flat();
    const [data] = await Promise.all([
      multiCall(
        NFTManagerContract.ABI,
        tokenIdsFlattened.map((tokenId) => ({
          address: NFTManagerContract.ADDRESS,
          name: "checkIfChestOpenedAndSet",
          params: [tokenId],
        }))
      ),
    ]);
    const openedTokens = [];
    tokenIdsFlattened.forEach((tokenId, index) => {
      const version = parseInt(data[index][0]);
      const isOpen = data[index][1];
      if (isOpen) openedTokens.push({ tokenId, version });
    });
    const [remainingTimes, metadata] = await Promise.all([
      multiCall(
        NFTTransmutationContract.ABI,
        openedTokens.map((item) => ({
          address: NFTTransmutationContract.ADDRESS,
          name: "getRemainingTime",
          params: [item.tokenId],
        }))
      ),
      multiCall(
        NFTCoreContract.ABI,
        openedTokens.map((item) => ({
          address: NFTCoreContract.ADDRESS,
          name: "getTokenMetadata",
          params: [item.tokenId],
        }))
      ),
    ]);
    const remainingTimesFlattened = remainingTimes.flat();
    const metadataFlattened = metadata.flat();
    let v1 = {};
    let v2 = {};
    let temp = metadataFlattened.map((item, index) => ({
      ...item,
      tokenId: parseInt(openedTokens[index].tokenId),
      version: openedTokens[index].version,
      remainingTime: parseInt(remainingTimesFlattened[index]),
    }));
    temp.forEach((item, _) => {
      if (parseInt(item.collectionId) !== 0) {
        const data = {
          tokenId: item.tokenId,
          version: item.version,
          set: parseInt(item.collectionId),
          rarity: parseInt(item.tokenRarity),
          type: parseInt(item.tokenType),
          exp: parseInt(item.experiencePoint),
          remainingTime: item.remainingTime,
          finishTimestamp: moment().add(item.remainingTime, "second").toDate().getTime(),
        };
        if (item.version == 1) v1[item.tokenId] = data;
        else if (item.version == 2) v2[item.tokenId] = data;
      }
    });
    return { v1, v2 };
  }
}
